export function RangeContent (pEditor, pRange)
{
  this.getHTML = (isRawHTML) =>
  {
    var currentSelection = pRange.selection.getCurrent(),
        currentRange = pRange.getCurrent(),
        parentElement,
        wholeText,
        domHelperElement,
        selectedHTML,
        selectedElement = null,
        isEqualInnerHTML = false,
        ret;

    if (BEditor.browser.isIE)
    {
      if (currentSelection.type.toUpperCase() === 'NONE')
      {
        return '';
      }

      selectedHTML = currentRange.htmlText;

      if (selectedHTML != null && !isRawHTML)
      {
        selectedHTML = selectedHTML.replace(/^\s*<[^>]+>([\S\s]*)<[^>]+>\s*$/i, '$1');
      }

      if (!selectedHTML && currentSelection.type == "Control")
      {
        selectedHTML = currentRange.item(0).innerHTML;
      }
    }
    else
    {
      if (currentRange.collapsed)
      {
        return '';
      }

      domHelperElement = pEditor.iFrameDoc.createElement('DIV');
      domHelperElement.appendChild(currentRange.cloneContents());
      selectedHTML = domHelperElement.innerHTML;
      domHelperElement.innerHTML = '';
      isEqualInnerHTML = (currentRange.commonAncestorContainer.innerHTML === selectedHTML);

      if ((currentRange.startContainer === currentRange.endContainer && currentRange.startContainer.parentElement) || isEqualInnerHTML)
      {
        parentElement = currentRange.startContainer.parentElement;

        if (parentElement.nodeName.toUpperCase() !== 'HTML' && !pEditor.checkAllBlockTags.test(parentElement.nodeName) && (pEditor.isChildrenOnlyTextNode(parentElement) || isEqualInnerHTML))
        {
          wholeText = parentElement.childNodes[0].wholeText;

          if (wholeText == null)
          {
            while (wholeText != null && parentElement.childNodes[0])
            {
              parentElement = parentElement.childNodes[0];
              wholeText = parentElement.childNodes[0].wholeText;
            }
          }

          if (!wholeText)
          {
            return selectedHTML;
          }

          if ((currentRange.startOffset === wholeText.length - wholeText.replace(/^\s+/, '').length && currentRange.endOffset === wholeText.replace(/\s+$/, '').length) || isEqualInnerHTML)
          {
            while (parentElement.parentElement && !pEditor.checkAllBlockTags.test(parentElement.parentElement.nodeName) && (pEditor.isOnlyTargetChildNode(parentElement.parentElement, parentElement) || isEqualInnerHTML))
            {
              isEqualInnerHTML = false;
              parentElement = parentElement.parentElement;
            }

            currentSelection.removeAllRanges();
            currentRange = pEditor.iFrameDoc.createRange();
            currentRange.selectNode(parentElement);
            currentSelection.addRange(currentRange);
            selectedElement = parentElement;
          }
        }
      }

      domHelperElement.appendChild(currentRange.cloneContents());
      selectedHTML = domHelperElement.innerHTML;
      domHelperElement = null;
    }

    selectedHTML = (selectedHTML != null) ? selectedHTML : '';
    ret = BEditor.device.isIOS ? { 'selectedHTML': selectedHTML, 'selectedElement': selectedElement } : selectedHTML;

    return ret;
  };


  this.getText = () =>
  {
    var currentSelection = pRange.selection.getCurrent(),
      currentRange = pRange.getCurrent(),
      domHelperElement,
      selectedText;

    if (BEditor.browser.isIE)
    {
      selectedText = currentRange.text;

      if (!selectedText && currentSelection.type == "Control")
      {
        selectedText = currentRange.item(0).innerHTML;
      }
    }
    else
    {
      domHelperElement = pEditor.iFrameDoc.createElement('DIV');
      domHelperElement.appendChild(currentRange.cloneContents());
      selectedText = currentRange.toString();
      domHelperElement = null;
    }

    return ((selectedText != null) ? selectedText : '');
  };
}